import React, { useEffect, useState } from 'react';
import { TotallingCalendar } from './TotallingCalendar';
import { getTotalingData } from '../../apicalls/attendanceManages';
import { checkResData } from '../../utils/common';
import { useSnackbar } from 'notistack';
import { TTotalingEvent, TTotalingResource } from '../../types/attendancManage';
import {
  GANTT_MINIMUM_HEIGHT,
  GANTT_SEARCH_HTML_ID
} from '../../const/ProcessConst';

type TProps = {
  type: number;
  initialVisibleRange: any;
};

export const TypeTotallingTab: React.FC<TProps> = (props: TProps) => {
  const { type, initialVisibleRange } = props;

  const { enqueueSnackbar } = useSnackbar();

  const [resources, setResources] = useState<TTotalingResource[]>([]);
  const [events, setEvents] = useState<TTotalingEvent[]>([]);

  useEffect(() => {
    getTotalingData(
      type,
      initialVisibleRange.start,
      initialVisibleRange.end
    ).then(resData => {
      checkResData(resData, enqueueSnackbar).then((data: any) => {
        if (data.data) {
          const tmpResources: TTotalingResource[] = [];
          const tmpEvents: TTotalingEvent[] = [];
          data.data.map((i: any) => {
            let total = 0;

            i.value.map((j: any) => {
              total += j[1];
              tmpEvents.push({
                id: j[0],
                title: j[1],
                start: j[0] + ' 00:00:00',
                end: j[0] + ' 23:59:59',
                resourceIds: [i.id],
                backgroundColor: '#FFCC00',
                borderColor: '#FFCC00',
                textColor: 'black'
              });
            });
            tmpResources.push({
              id: i.id,
              title: i.name,
              totalling: total
            });
          });
          setResources(tmpResources);
          setEvents(tmpEvents);
        }
      });
    });
  }, [initialVisibleRange.start, initialVisibleRange.end]);

  return (
    <div style={{ padding: '15px' }}>
      {resources.length > 0 && events.length > 0 && (
        <TotallingCalendar
          resources={resources}
          events={events}
          initialVisibleRange={initialVisibleRange}
        />
      )}
    </div>
  );
};
